export const SOLANA_SIGNATURE_MESSAGES = {
   AUTH: {
      MESSAGE_SHORT: (token: string) => `Auth Request - Session: ${token}`,
      MESSAGE_LONG: (token: string) => `Wallet confirmation ⛳ \n\nI have read and agreed to the Terms and Conditions.\n\nNo amount will be charged.\n\nSession: ${token}`,
   },
   CONVERSION_ACTIVATION: {
      // prism
      MESSAGE_SHORT: (token: string, cost: number) => `Conversion Activation - Cost: ${cost} points - Session: ${token}`,
      MESSAGE_LONG: (token: string, cost: number) => `Conversion Activation Requested - Cost: ${cost} points - Session: ${token}`,
   },
   WITHDRAW: {
      MESSAGE_SHORT: (token: string, amount: number) => `Withdraw Request - Amount: ${amount} points - Session: ${token}`,
      MESSAGE_LONG: (token: string, amount: number) => `Withdraw Requested - Amount: ${amount} points - Session: ${token}`,
   },
};
